module.exports = __webpack_public_path__ + "media/img/pole_a@2x-8e256c67.png";